import React from "react";

const Pokupki = (props) => {
    return (
        <>Pokupki</>
    )
}

export default Pokupki;